import { TFunction, useTranslation } from "react-i18next";
import { AccordionSummary, ListItem, ListItemText } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  AccountAvatar,
  AccountDetails,
  AccountIcon,
  AccountItemContainer,
} from "./styled";
import ItemContent from "pages/Accounts/AccountList/ItemContent";
import { Account } from "@dashboard-v3/api";
import { LoadedFile } from "../types";
import TruncatedText from "components/TruncatedText";

interface Props {
  item: LoadedFile["items"][number];
  saveError?: string;
}

export default function AccountItem({ item, saveError }: Props) {
  const { t } = useTranslation("accounts");

  const { account, approvalGroups } = item;
  const { email } = account;
  // delete-only rows carry just the email, there is nothing to expand
  const expandable = !!account.storage;

  return (
    <ListItem disableGutters>
      <AccountItemContainer>
        <AccordionSummary expandIcon={expandable ? <ExpandMoreIcon /> : null}>
          <AccountIcon>
            <AccountAvatar>{email.charAt(0)}</AccountAvatar>
          </AccountIcon>
          <ListItemText
            style={{ overflow: "hidden" }}
            primary={<TruncatedText text={email} maxWidth={350} />}
            secondary={saveError || ""}
            primaryTypographyProps={{
              variant: "caption",
              style: { fontSize: "14px" },
            }}
            secondaryTypographyProps={{
              variant: "caption",
              color: "error",
              style: { lineHeight: 1 },
            }}
          />
        </AccordionSummary>
        {expandable && (
          <AccountDetails>
            <ItemContent
              account={completeFields(account, t)}
              validateStorage={false}
              approvalGroups={approvalGroups}
            />
          </AccountDetails>
        )}
      </AccountItemContainer>
    </ListItem>
  );
}

function completeFields(account: Props["item"]["account"], t: TFunction) {
  return {
    ...account,
    groups: [],
    sourceType: "MANUAL" as Account["sourceType"],
    sourceLabel: t("source.manual"),
  };
}
